import { render } from "./2022-10-26-bibao.md?vue&type=template&id=9fe7670c"
const script = {}
script.render = render

export default script